import { Divider, Flex, Heading } from '@chakra-ui/react'
import React from 'react'

const SectionHeader = ({ title = 'Section', rightElement, hasDivider = true, mt = '5' }) => {
  return (
    <>
      <Flex justifyContent="space-between" px="1" py="2" mt={mt}>
        <Heading size="md" mb="4">
          <Flex gap={4}>{title}</Flex>
        </Heading>

        {rightElement}
      </Flex>
      {hasDivider && <Divider />}
    </>
  )
}

export default SectionHeader
